// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__UBgsq","flip":"loader_flip__xMaCl"};